export default {
  setSelected (state, payload) {
    const number = payload.number

    if (payload.over) {
      state.selected[number] = false
    } else {
      state.selected[number] = !state.selected[number]
    }
  },

  setSubmit (state, submit) {
    state.submit = submit
  }
}
